// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".-complex-table{position:relative}.-complex-table table{background:#fff}.-table-body,.-table-footer,.-table-header{position:relative;overflow:scroll}.-fixed-table{position:absolute;top:0}.-fixed-table table{width:auto}.-left-fixed,.-right-fixed{box-shadow:1px 0 5px #ddd}", ""]);
// Exports
module.exports = exports;
